import React from 'react';
import {ListItem, ListItemText, List } from '@mui/material';
import Icon from '@mui/material/Icon';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import {useStyles} from './style';
import EnlaceDeLista from 'components/EnlaceDeLista';

export default function ListaDeGrupo(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    function handleClick() {
        setOpen(!open);
    }

    const handleDrawerClose=(props)=> {
        setOpen(false);
    }

    if (props.listOfGroup===null || props.listOfGroup=== undefined){
        return <div></div>;
    }

    return (
        <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
            <ListItem button onClick={handleClick}>
                <Icon className={classes.icon}>{props.listOfGroup.icon}</Icon>
                <ListItemText className={classes.name} secondary={props.listOfGroup.name} to={"/home"}></ListItemText>
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={open} timeout="auto" >
                <List component="div" disablePadding onClick={handleDrawerClose}>
                    {props.listOfGroup.form.map((option, index) => (
                        <EnlaceDeLista  key={index} to={option.path} primary={option.name} icon={option.icon}  isNested={true}></EnlaceDeLista>
                ))}
                </List>
            </Collapse>
        </List>
    );
}